export default __webpack_public_path__ + "static/media/Apercu.8c3d5a90.otf";